import firebase from 'firebase'

let database = null
let fireStoreDb = null

const init = function () {
  database = firebase.database()
  fireStoreDb = firebase.firestore()

  if (window.location.hostname === "192.168.86.53") {
    //firebase.functions().useFunctionsEmulator("http://localhost:5001")

    fireStoreDb.settings({
      host: "192.168.86.53:8080",
      ssl: false
    });
  }
}

const getRef = function (path) {
  return database.ref(path)
}

const getDb = function () {
  return database
}

const getFireStoreColl = function (path) {
  return fireStoreDb.collection(path)
}

const getFireStoreDoc = function (path) {
  return fireStoreDb.doc(path)
}

const getFireStoreDb = function () {
  return fireStoreDb
}

export default { init, getRef, getDb, getFireStoreDb, getFireStoreColl, getFireStoreDoc }


// WEBPACK FOOTER //
// ./src/components/webmaster/Database/database.js